import React, { Component } from "react";
import { ButtonToolbar, Table, Grid } from 'react-bootstrap';

import { PropTypes } from 'prop-types';
import { LoadingSpinner } from '../../LoadingSpinner';
import { SortIndicator } from '../../SortIndicator';
import { PaginationBuilder } from '../../PaginationBuilder';
import { SearchHelper } from '../../helpers/SearchHelper';
import { ComparisonHelper } from '../../helpers/ComparisonHelper';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { TableButton } from '../../TableButton';

export class SchedulesDraft extends Component {
    static contextTypes = {
        edition: PropTypes.object
    }
    
    constructor(props) {
        super(props);

        this.state = {
            render: {
                sort: {
                    property: "name",
                    type: "ascending"
                }
            }
        }
    }

    // -----------------------

    onChangeSort(property) {
        const { render } = this.state;

        render.sort.type = render.sort.property === property && "ascending" === render.sort.type ? "descending" : "ascending";
        render.sort.property = property;

        this.setState({
            render: render
        });
    }

    // -----------------------

    sortSchedules(sort, a, b) {
        let aValue = a[sort.property];
        let bValue = b[sort.property];

        if ("object" === typeof aValue) {
            aValue = undefined !== aValue.left ? aValue.left : aValue.right;
        }

        if ("object" === typeof bValue) {
            bValue = undefined !== bValue.left ? bValue.left : bValue.right;
        }

        if (aValue === bValue) {
            return 0;
        }

        const output = aValue < bValue ? -1 : 1;

        if ("descending" === sort.type) {
            return output * -1;
        }

        return output;
    }

    // -----------------------

    renderLoading(isLoading) {
        if (isLoading) {
            return (
                <LoadingSpinner />
            );
        }

        return null;
    }

    renderSortIndicator(property, sort) {
        if (property !== sort.property) {
            return (
                <SortIndicator order="none" />
            );
        }

        return (
            <SortIndicator order={sort.type} />
        );
    }

    render() {
        const { edition } = this.context;

        if (null === edition || undefined === edition) {
            return null;
        }

        const { schedules, isLoading, currentPage, elementsPerPage, isComparing, filter } = this.props;
        const { render } = this.state;

        let schedulesFiltered;
        if (isComparing) {
            const { draftSchedules } = this.props;

            schedulesFiltered = SearchHelper.search({
                filter: filter,
                data: ComparisonHelper.compare(
                    schedules,
                    draftSchedules || [],
                    {
                        match: [{ left: "name", right: "name" }],
                        fields: [{ left: "setOfDayTypesName", right: "setOfDayTypesName" }]
                    }),
                fields: ["name", "name.left", "name.right", "setOfDayTypesName", "setOfDayTypesName.left", "setOfDayTypesName.right"]
            });
        }
        else {
            schedulesFiltered = SearchHelper.search({
                filter: filter,
                data: schedules,
                fields: ["name", "setOfDayTypesName"]
            });
        }

        const totalPages = PaginationHelper.getTotalPages(schedulesFiltered.length, elementsPerPage);
        const activePage = totalPages < currentPage ? totalPages : currentPage;
        const schedulesToRender = schedulesFiltered.sort((a, b) => this.sortSchedules(render.sort, a, b))
            .slice((activePage - 1) * elementsPerPage, activePage * elementsPerPage);

        return (
            <Grid fluid className="table-small-screens">
                <div className="table-loading">
                    <Table responsive striped hover>
                        <thead>
                            <tr>
                                <th className="width-50p sortable" onClick={() => this.onChangeSort("name")}>Nome {this.renderSortIndicator("name", render.sort)}</th>
                                <th className="width-20p">Conjunto de Tipos de Dia</th>
                                <th className="width-20p">Edição</th>
                                <th className="width-10p">&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody className={isLoading ? "overlay" : ""}>
                            {
                                schedulesToRender.map((schedule, idx) =>
                                    <tr key={`schedule-${idx}`}>
                                        <td>{schedule.name}</td>
                                        <td>{schedule.setOfDayTypesName}</td>
                                        <td>{edition.getDraftPlanningEditionName(schedule.planningEdition)}</td>
                                        <td>
                                            <ButtonToolbar className="pull-right">
                                                <TableButton marginRight icon="icon-edit" title="Editar" onClick={() => this.props.onEditClick(schedule)} />
                                                <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.props.onDeleteClick(schedule)} />
                                            </ButtonToolbar>
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </Table>

                    <PaginationBuilder
                        currentPage={activePage}
                        elementsPerPage={elementsPerPage}
                        dataLength={schedulesFiltered.length}
                        onChangePage={(a) => this.props.onChangePage(a)}
                        onChangeElementsPerPage={(a) => this.props.onChangeElementsPerPage(a)} />

                    {this.renderLoading(isLoading)}
                </div>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/schedules/SchedulesDraft.js